import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { StyledColorInput } from "./styles";

import colors from "core/colors";

import { normalizeHexCode } from "icons/IconEditor/helpers";
import { isHex } from "./helpers";
import { useIconEditorDispatch } from "js/contexts/IconEditorContext";
import { convertPxToRem } from "frontend/components/helpers";

const HexColorInput = ({
    activeColor = "",
    setActiveColor,
    colorTextInputValue,
    background
}) => {
    const dispatch = useIconEditorDispatch();

    const handleInputChange = ({ input }) => {
        const normalizedInput = normalizeHexCode({ hexCode: input });
        const normalizedActiveColor = normalizeHexCode({
            hexCode: activeColor
        });

        if (normalizedInput !== normalizedActiveColor) {
            if (normalizedInput.length === 7) {
                if (isHex.test(normalizedInput)) {
                    setActiveColor({ color: normalizedInput });
                } else {
                    setActiveColor({
                        color: normalizeHexCode({
                            hexCode: colors.secondary.onyx
                        })
                    });
                }
            }
        }

        const actionType = background
            ? "UPDATE_BACKGROUND_COLOR_TEXT_INPUT_VALUE"
            : "UPDATE_ICON_COLOR_TEXT_INPUT_VALUE";

        dispatch({
            type: actionType,
            payload: normalizedInput
        });
    };

    useEffect(() => {
        const normalizedColorTextInputValue = normalizeHexCode({
            hexCode: colorTextInputValue
        });
        const normalizedActiveColor = normalizeHexCode({
            hexCode: activeColor
        });

        if (normalizedActiveColor !== normalizedColorTextInputValue) {
            handleInputChange({ input: normalizedActiveColor });
        }
    }, [activeColor]);

    return (
        <StyledColorInput
            value={colorTextInputValue}
            onChange={e => handleInputChange({ input: e.target.value })}
            aria-label="selected color"
            maxLength={7}
            width={convertPxToRem({ px: 80 })}
            placeholder="#HEX"
        />
    );
};

HexColorInput.propTypes = {
    activeColor: PropTypes.string.isRequired,
    setActiveColor: PropTypes.func.isRequired,
    colorTextInputValue: PropTypes.string,
    background: PropTypes.bool
};

export default HexColorInput;
